import {
  GmailDnsRecordKind,
  GmailDnsRecordStatus,
  gmailDnsRecordNeedsAction,
} from "@redotech/redo-communication-channels-email-gmail-common";
import { RedoMerchantClient } from "@redotech/redo-merchant-app-common/client";

export { GmailDnsRecordKind, GmailDnsRecordStatus, gmailDnsRecordNeedsAction };

export interface GmailDnsCheckResponse {
  domain: string;
  result: Record<
    GmailDnsRecordKind,
    { status: GmailDnsRecordStatus; observed?: string | null }
  >;
}

export async function checkGmailDns(
  client: RedoMerchantClient,
  { integrationId, signal }: { integrationId: string; signal?: AbortSignal },
): Promise<GmailDnsCheckResponse> {
  const response = await client.client.get(
    `support/gmail/${integrationId}/dns-check`,
    { headers: client.authorization(), signal },
  );
  return response.data;
}

export async function getGmailIntegrations(
  client: RedoMerchantClient,
  { signal }: { signal?: AbortSignal } = {},
): Promise<any> {
  const response = await client.client.get("support/gmail", {
    headers: client.authorization(),
    signal,
  });
  return response.data;
}

export async function deleteGmailIntegration(
  client: RedoMerchantClient,
  {
    integrationId,
    signal,
    deleteConversations,
  }: {
    integrationId: string;
    deleteConversations: boolean;
    signal?: AbortSignal;
  },
): Promise<void> {
  const params = new URLSearchParams();
  params.set("deleteConversations", deleteConversations.toString());
  const response = await client.client.delete(
    `support/gmail/${integrationId}`,
    { headers: client.authorization(), params, signal },
  );
  return response.data;
}
